// /* eslint-disable */
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { ConfirmDialog } from "primereact/confirmdialog";
import colors from "./assets/ts/colors";
import AppRoutes from "./routes/Routes";
import { requestFCMToken } from "./firebase/firebase-config";
import { RootState } from "./redux/store";
import ScrollToTop from "./components/common/ScrollToTop";
import AnalyticsTracker from "./components/common/AnalyticsTracker";

const App: React.FC = () => {
  // This bundle also serves the public marketing site (sagarsamaj.in/, /p/*),
  // where an anonymous visitor has no reason to be asked for notifications —
  // that's what triggered Lighthouse's "requests notification permission on
  // page load" flag and, once a visitor blocks it, a console error on every
  // later page load (getToken() throwing on a permanently-blocked origin).
  // Gate it to actual logged-in admin/staff sessions instead.
  const token = useSelector((state: RootState) => state.auth.token);

  useEffect(() => {
    if (token) requestFCMToken();
    // Set CSS custom properties (variables)
    Object.keys(colors).forEach((key) => {
      document.documentElement.style.setProperty(
        `--${key}`,
        colors[key as keyof typeof colors]
      );
    });
  }, [token]);
  return (
    <>
      <ScrollToTop />
      <AnalyticsTracker />
      {/* Single instance for the whole app — call PrimeReact's imperative
          confirmDialog({ message, accept, reject }) from anywhere instead of
          the native window.confirm/alert popups. */}
      <ConfirmDialog />
      <AppRoutes />
    </>
  );
};

export default App;

